module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_21-4a0a21af918824bb1f0458c75601ac98.jpg";